/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

(function () {
  if (window.__kachingPlanSync) return;
  window.__kachingPlanSync = true;

  var PRODUCT_ID = 16077885473098;
  var PLAN_SMALL = 693403484490; // Buy One + Buy 1 Get 1 Free
  var PLAN_BIG = 693403451722;   // Buy 2 Get 2 Free
  var BARS = {
    rZM7: { 1: 'd2d30b5e-3db0-437b-8c33-6c9227335d95', 2: '68dc0031-882d-42fc-9040-558140cf2a92', 4: 'fc3ee748-1d4b-4f1e-9165-e7243d432328' },
    Krl8: { 1: 'c10a93c1-dc98-49cc-b9be-5783c3a7a4d3', 2: '61e3b170-8b7a-43fe-98a2-ed2bb8709091', 4: 'a8449dea-8268-4635-aadd-52e15b0e1d27' },
    lJ0U: { 1: 'df65e85e-9330-4a41-91cc-868aac364d21', 2: 'a9e49305-eb4f-4a9e-865d-9ac98c928a35', 4: '74b428f0-9385-4518-af54-ddd3a63eae70' }
  };

  var origFetch = window.fetch.bind(window);
  var busy = false;

  function findFix(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (item.product_id !== PRODUCT_ID || !item.selling_plan_allocation) continue;
      var kb;
      try { kb = JSON.parse(item.properties.__kaching_bundles); } catch (e) { continue; }
      var bars = BARS[kb.deal];
      if (!bars) continue;

      var tier = item.quantity >= 4 ? 4 : (item.quantity >= 2 ? 2 : 1);
      var plan = tier === 4 ? PLAN_BIG : PLAN_SMALL;
      if (item.selling_plan_allocation.selling_plan.id === plan && kb.bid === bars[tier]) continue;

      kb.bid = bars[tier];
      if (tier === 1) delete kb.sellingPlan;
      else kb.sellingPlan = { id: plan, priceAdjustment: { type: 'percentage', value: tier === 4 ? 15 : 10 } };

      var props = Object.assign({}, item.properties, { __kaching_bundles: JSON.stringify(kb) });
      return { id: item.key, quantity: item.quantity, selling_plan: plan, properties: props };
    }
    return null;
  }

  async function reconcile(sections) {
    if (busy) return null;
    busy = true;
    var last = null;
    try {
      for (var pass = 0; pass < 5; pass++) {
        var cart = await (await origFetch('/cart.js')).json();
        var body = findFix(cart);
        if (!body && pass === 0) {
          // Shopify can return the old cart for a moment after an add. Check again.
          await new Promise(function (r) { setTimeout(r, 700); });
          cart = await (await origFetch('/cart.js')).json();
          body = findFix(cart);
        }
        if (!body) break;
        if (sections) body.sections = sections;
        var res = await origFetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        });
        if (!res.ok) break;
        last = await res.json();
      }
    } catch (e) {
      console.warn('[kaching plan sync]', e);
    }
    busy = false;
    return last;
  }

  window.fetch = async function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var res = await origFetch(input, init);
    if (!res.ok || !/\/cart\/(add|change|update)/.test(url)) return res;

    var sections = null;
    try { sections = JSON.parse(init.body).sections || null; } catch (e) {}

    var fixed = await reconcile(sections);
    if (!fixed) return res;

    var out = fixed;
    if (/\/cart\/add/.test(url)) {
      out = await res.clone().json();
      if (out.sections && fixed.sections) out.sections = fixed.sections;
    }
    return new Response(JSON.stringify(out), { status: 200, headers: { 'Content-Type': 'application/json' } });
  };

  if (/^\/cart\/?$/.test(location.pathname)) {
    reconcile(null).then(function (fixed) { if (fixed) location.reload(); });
  }
})();